export const authConfig = {
  storageTokenKeyName: "accessToken",
  usersname: "setUsersName",
  usersEmail: "usersEmail",
  appName: "FlightPadi",
};
